module.exports = __webpack_public_path__ + "static/img/pic0@3x.8b764db.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/about/A09_lxwm/pic0@3x.png
// module id = 1ZTw
// module chunks = 0